/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRegimenDrug } from 'app/shared/model/regimen-drug.model';

export interface IDrugConstraint {
  id?: string;
  description?: string | null;
  type?: string | null;
  value?: string | null;
  priority?: string | null;
  unit?: string | null;
  startConstraint?: string | null;
  endConstraint?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  drug?: IRegimenDrug | null;
}

export const defaultValue: Readonly<IDrugConstraint> = {
  active: false,
};
